import { z } from "zod";
import { PRIORITIES } from "../status.js";

const nullableText = (max: number) => z.string().trim().max(max).nullable();

export const aiRequestFieldsSchema = z.object({
  shortDescription: nullableText(180),
  description: nullableText(6000),
  categoryId: z.string().uuid().nullable(),
  subcategoryId: z.string().uuid().nullable(),
  pricingPreference: z
    .enum(["offer_required", "fixed_price", "time_and_material"])
    .nullable(),
  fixedAmount: z
    .string()
    .regex(/^\d+(\.\d{1,2})?$/)
    .nullable(),
  schedulingPreference: z.enum(["asap", "desired_date"]).nullable(),
  requestedDate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .nullable(),
  requestedTimeStart: z
    .string()
    .regex(/^([01]\d|2[0-3]):(00|15|30|45)$/)
    .nullable(),
  requestedTimeEnd: z
    .string()
    .regex(/^([01]\d|2[0-3]):(00|15|30|45)$/)
    .nullable(),
  priority: z.enum(PRIORITIES).nullable(),
});
export type AIRequestFields = z.infer<typeof aiRequestFieldsSchema>;

export const aiAutocompleteSchema = z.object({
  prompt: z.string().trim().min(3).max(12000),
});
export type AIAutocompleteDto = z.infer<typeof aiAutocompleteSchema>;

export const aiRequestResultSchema = z.object({
  transcript: z.string().max(12000).nullable(),
  fields: aiRequestFieldsSchema,
  warnings: z.array(z.string().max(300)).max(20).default([]),
});
export type AIRequestResult = z.infer<typeof aiRequestResultSchema>;

export interface AIAvailabilityResponse {
  enabled: boolean;
  allowed: boolean;
  model?: string;
  monthlyBudgetUsd: string;
  usedUsd: string;
  remainingUsd: string;
}

export interface AIUsageUserRow {
  userId: string;
  displayName: string;
  requestCount: number;
  inputTokens: number;
  outputTokens: number;
  totalTokens: number;
  costUsd: string;
}

export interface AIUsageStatsResponse {
  month: string;
  configured: boolean;
  model: string;
  monthlyBudgetUsd: string;
  usedUsd: string;
  remainingUsd: string;
  requestCount: number;
  users: AIUsageUserRow[];
}
